import { Link } from "react-router-dom";
import { seo } from "../../data/site";
import { useDocumentMeta } from "../../hooks/useDocumentMeta";

export function NotFoundPage() {
  useDocumentMeta(seo.notFound);
  return <section className="section page-view"><div className="section-heading"><h1>This page is not available.</h1><p>The page may have moved, or the link may be incomplete. Return to the homepage or review the available services.</p></div><Link className="primary-action" to="/">Go to Home</Link></section>;
}
